export default {
  'Watermark': "Marca d'água",
  'Add Watermark Selection': "Clique e Arraste Mouse para Adicionar Seleções de Marca D'água",
}